/**
 * Display name of a language in the current UI language. The stored value (what the profile and the
 * listing keep, and what matching compares) is always the English name; only the display changes.
 * `inline` keeps the translation as written (lowercase in Spanish, for running text such as
 * "Bilingüe en español preferido"); otherwise the first letter is capitalised for chips and lists.
 */
export function languageLabel(t, name, { inline = false } = {}) {
  const raw = String(name ?? "").trim();
  if (!raw) return "";
  const label = t(`languageNames.${raw}`, { defaultValue: raw });
  return inline || !label ? label : label.charAt(0).toLocaleUpperCase() + label.slice(1);
}
